import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { LiveLessonTag, liveLessonTagRoute } from 'src/app/types/live-lesson-types';

@Component({
  selector: 'app-live-lesson-tag',
  templateUrl: './live-lesson-tag.component.html',
  styleUrl: './live-lesson-tag.component.scss',
})
export class LiveLessonTagComponent {
  tag = input.required<LiveLessonTag>();
  /** Only the "primary course badge" call sites (schedule item, detail, live-card) pass true. */
  showIcon = input<boolean>(false);

  private router = inject(Router);

  get route(): string[] | null {
    return liveLessonTagRoute(this.tag());
  }

  /** A plain <span> rather than routerLink/<a> — some call sites nest this inside another <a> (the lesson card), where a real nested anchor would be invalid HTML. */
  onActivate(event: Event): void {
    const route = this.route;
    if (!route) return;

    event.stopPropagation();
    event.preventDefault();
    this.router.navigate(route);
  }
}
